import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import Confirmation from "./pages/confiramtion";
import Report from "./pages/report";
import ResidentManagement from "./pages/residentmanagement";
import Admin from "./pages/admin";
import StaffManagement from "./pages/staffmanagement";
import AdminReports from "./pages/adminreport";
import PropertyManagement from "./pages/propertymanagement";
import Executive from "./pages/executive";
import ExecutiveReport from "./pages/executivereport";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/report" element={<Report />} />
        <Route path="/resident" element={<ResidentManagement />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/staff" element={<StaffManagement />} />
        <Route path="/adminreport" element={<AdminReports />} />
        <Route path="/property" element={<PropertyManagement />} />
        <Route path="/executive" element={<Executive />} />
        <Route path="/executivereport" element={<ExecutiveReport />} />
      </Routes>
    </Router>
  );
}

export default App;
